import * as THREE from 'three';

export class SystemBase {
  loader: any;
  calc: any;
  ease: any;
  sphereGeometry: THREE.SphereGeometry;
  boxGeometry: THREE.BoxGeometry;
  center: THREE.Vector3;
  particles: any[];
  particleGroup: THREE.Object3D;
  entering: boolean;
  enterProgress: number;
  enterRate: number;
  exiting: boolean;
  exitProgress: number;
  exitRate: number;
  duration: number;

  constructor(loader: any) {
    this.loader = loader;
    this.calc = loader.calc;
    this.ease = loader.ease;
    this.sphereGeometry = new THREE.SphereGeometry(1, 16, 16);
    this.boxGeometry = new THREE.BoxGeometry(1, 1, 1);
    this.center = new THREE.Vector3();
    this.particles = [];
    this.particleGroup = new THREE.Object3D();
    this.particleGroup.scale.set(0.0001, 0.0001, 0.0001);
    loader.scene.add(this.particleGroup);

    this.entering = true;
    this.enterProgress = 0;
    this.enterRate = 0.015;
    this.exiting = false;
    this.exitProgress = 0;
    this.exitRate = 0.005;
    this.duration = Infinity;
  }

  update() {
    for (const p of this.particles) p.update?.();

    if (this.entering && this.enterProgress < 1) {
      this.enterProgress += this.enterRate * this.loader.deltaTimeNormal;
      if (this.enterProgress > 1) {
        this.enterProgress = 1;
        this.entering = false;
      }
      const scale = this.ease.inOutExpo(this.enterProgress, 0, 1, 1);
      this.particleGroup.scale.set(scale, scale, scale);
    }

    if (!this.exiting && this.loader.elapsedMilliseconds > this.duration) this.exiting = true;

    if (this.exiting) {
      this.exitProgress += this.exitRate * this.loader.deltaTimeNormal;
      if (this.exitProgress >= 1 && !this.loader.completed) {
        this.exitProgress = 1;
        this.loader.complete();
      }
    }
  }

  replay() {
    this.particleGroup.scale.set(0.0001, 0.0001, 0.0001);
    for (const p of this.particles) p.reset?.();
    this.entering = true;
    this.enterProgress = 0;
    this.exiting = false;
    this.exitProgress = 0;
  }
}
